import { message } from 'antd'

import { fetchUtil as fetch } from 'src/utils/fetch'
import { saveAuditData } from 'src/api/audit'

export const createRedeemCode = async (providerCountry, subscriptionType) => {
  try {
    const { data } = await fetch(
      `/payment/redeem/create/${providerCountry}/${subscriptionType}`,
      {
        method: 'PUT',
        headers: {
          role: 'ADMIN',
        },
      }
    )
    saveAuditData(
      'CREATE',
      'REDEEM-CODE',
      JSON.stringify({
        country: providerCountry,
        type: subscriptionType,
      })
    )
    return data
  } catch (e) {
    message.error('Save State Error !')
  }
}

export const getAllRedeemCodes = async (
  page = 0,
  size = 10,
  providerCountry,
  redeemed,
  subscriptionType
) => {
  const requestBody: {
    page: number
    size: number
    providerCountry?: string
    redeemed?: boolean
    subscriptionType?: string
  } = { page, size }

  if (providerCountry != null && providerCountry != '') {
    requestBody.providerCountry = providerCountry
  }

  if (redeemed != null && redeemed != '') {
    requestBody.redeemed = redeemed
  }

  if (subscriptionType != null && subscriptionType != '') {
    requestBody.subscriptionType = subscriptionType
  }

  const { data } = await fetch(`/payment/redeem/all`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      role: 'ADMIN',
    },
  })
  return data
}
